export default (element, event, detail = {}) => {
    element === null || element === void 0 ? void 0 : element.dispatchEvent(new CustomEvent(event, {
        composed: true,
        detail
    }));
};
